// ===== BUSINESS, COMMERCE & MANAGEMENT =====
const COMMERCE_MGMT = [
  {
    id: "bba",
    name: "B.B.A – Bachelor of Business Administration",
    stream: "commerce",
    category: "commerce-mgmt",
    summary:
      "Foundation in management principles, finance, HR, marketing, operations, and entrepreneurship.",
    eligibility: "10+2 in any stream; many universities via CUET UG or institute-specific entrance exams.",
    exams: ["CUET UG", "IPMAT", "NPAT", "SET", "State CETs"],
    colleges: [
      "Shaheed Sukhdev College of Business Studies (DU)",
      "Christ University, Bengaluru",
      "Symbiosis Centre for Management Studies, Pune",
      "NMIMS Mumbai",
      "IIM Indore – IPM"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["management", "finance", "HR", "marketing", "entrepreneurship"],
  },
  {
    id: "bcom",
    name: "B.Com – Bachelor of Commerce",
    stream: "commerce",
    category: "commerce-mgmt",
    summary:
      "Accounting, taxation, finance, auditing, economics, business law, and corporate management.",
    eligibility: "10+2 in any stream; CUET UG or institute-specific entrance exams.",
    exams: ["CUET UG", "SET", "State CETs"],
    colleges: [
      "Shri Ram College of Commerce (SRCC), Delhi University",
      "Loyola College, Chennai",
      "Christ University, Bengaluru",
      "Hindu College, Delhi University",
      "St. Xavier's College, Mumbai"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["accounting", "finance", "taxation", "auditing"],
  },
  {
    id: "bms",
    name: "B.M.S – Bachelor of Management Studies",
    stream: "commerce",
    category: "commerce-mgmt",
    summary:
      "Comprehensive business education with specializations in finance, marketing, HR, and operations.",
    eligibility: "10+2 in any stream; CUET UG, NPAT, or institute-specific exams.",
    exams: ["CUET UG", "NPAT", "SET", "State CETs"],
    colleges: [
      "NMIMS Mumbai",
      "KJ Somaiya College of Arts & Commerce, Mumbai",
      "Christ University, Bengaluru",
      "HR College of Commerce, Mumbai"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["management", "business", "finance", "HR", "marketing"],
  },
  {
    id: "bbm",
    name: "B.B.M – Bachelor of Business Management",
    stream: "commerce",
    category: "commerce-mgmt",
    summary:
      "Focus on corporate management, business operations, entrepreneurship, and marketing.",
    eligibility: "10+2 in any stream; CUET UG or institute-specific entrance exams.",
    exams: ["CUET UG", "NPAT", "SET", "State CETs"],
    colleges: [
      "St. Xavier's College, Mumbai",
      "Christ University, Bengaluru",
      "NMIMS Mumbai",
      "Loyola College, Chennai"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["business", "management", "entrepreneurship", "marketing"],
  },
  {
    id: "bfa",
    name: "B.F.A – Bachelor of Finance & Accounting",
    stream: "commerce",
    category: "commerce-mgmt",
    summary:
      "Accounting, auditing, financial management, taxation, corporate finance, and investment analysis.",
    eligibility: "10+2 in any stream; CUET UG or institute-specific exams.",
    exams: ["CUET UG", "SET", "NPAT", "State CETs"],
    colleges: [
      "NMIMS Mumbai",
      "Shaheed Sukhdev College of Business Studies (DU)",
      "Christ University, Bengaluru",
      "Loyola College, Chennai"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["finance", "accounting", "investment", "taxation"],
  },
  {
    id: "hotel-mgmt",
    name: "B.Sc in Hotel & Hospitality Management",
    stream: "commerce",
    category: "commerce-mgmt",
    summary:
      "Covers hotel operations, food & beverage, housekeeping, front office, tourism, and management.",
    eligibility: "10+2 in any stream; NCHMCT JEE or institute-specific exams.",
    exams: ["NCHMCT JEE", "State CETs", "CUET UG"],
    colleges: [
      "Institute of Hotel Management (IHM) Pusa, Delhi",
      "IHM Mumbai",
      "IHM Bangalore",
      "IHM Hyderabad",
      "Christ University, Bengaluru"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["hospitality", "tourism", "hotel", "management", "food & beverage"],
  },
  {
    id: "event-mgmt",
    name: "B.Sc in Event Management",
    stream: "commerce",
    category: "commerce-mgmt",
    summary:
      "Planning, organizing, and executing events with focus on marketing, logistics, and client management.",
    eligibility: "10+2 in any stream; CUET UG or institute-specific exams.",
    exams: ["CUET UG", "State CETs"],
    colleges: [
      "Christ University, Bengaluru",
      "Pearl Academy, Delhi",
      "NMIMS Mumbai",
      "Banaras Hindu University (BHU)"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["events", "logistics", "marketing", "management"],
  },
  {
    id: "logistics-mgmt",
    name: "B.Sc in Logistics & Supply Chain Management",
    stream: "commerce",
    category: "commerce-mgmt",
    summary:
      "Operations, procurement, transportation, inventory management, and supply chain analytics.",
    eligibility: "10+2 in any stream; CUET UG or institute-specific exams.",
    exams: ["CUET UG", "NPAT", "State CETs"],
    colleges: [
      "NMIMS Mumbai",
      "Christ University, Bengaluru",
      "IIFT Delhi",
      "Shri Ram College of Commerce (DU)"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["supply chain", "logistics", "operations", "procurement"],
  },
  {
    id: "bcom-hons",
    name: "B.Com (Hons.) – Bachelor of Commerce (Honours)",
    stream: "commerce",
    category: "commerce-mgmt",
    summary:
      "Advanced focus on finance, accounting, taxation, auditing, and business management.",
    eligibility: "10+2 in any stream; CUET UG, Delhi University or state CETs.",
    exams: ["CUET UG", "SET", "State CETs"],
    colleges: [
      "Shri Ram College of Commerce (SRCC), Delhi University",
      "Lady Shri Ram College (LSR), Delhi University",
      "St. Xavier's College, Mumbai",
      "Christ University, Bengaluru"
    ],
    source: "Our data, thoughtfully compiled by PrepX Pathshala. Please verify with official sites.",
    keywords: ["accounting", "finance", "taxation", "business", "commerce"],
  },
];

export default COMMERCE_MGMT;
